import { render } from "./ModelBody.vue?vue&type=template&id=003623ae"
import script from "./ModelBody.vue?vue&type=script&lang=js"
export * from "./ModelBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__